module.exports = __webpack_public_path__ + "static/2-c142a840d94aedb0b1f677dfed2e07c4.jpg";